var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-filter'),_vm._l((_vm._products),function(product){return _c('product',{key:product.id,attrs:{"product":product}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }